import styled from 'styled-components';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface IconProps {
  isOpen: boolean;
}

export const CloseSummaryIcon = styled(ArrowDropDownIcon)<IconProps>(({ isOpen }) => ({
  background: `${isOpen ? '#0C7CBB' : '#EBEFF3'}`,
  color: `${isOpen ? 'white' : 'black'}`,
  width: '3rem',
  height: '3rem',
  borderRadius: '5px',
}));

export const SummaryBackgroundStyle = {
  p: 1,
  background: '#f8fbfd',
  border: '0.1rem solid #d6dce4',
  // borderTop: '0.1rem solid #d6dce4',

  '@media only screen and (max-width: 1728px)': {
    padding: 0,
  },
};
